import { Config } from '../model/config';

export class FeatureToggle {
  private static deprecatedExpireEvents = false;

  public static init(config: Pick<Config, 'deprecatedExpireEvents'>) {
    if ('deprecatedExpireEvents' in config) {
      FeatureToggle.deprecatedExpireEvents = config.deprecatedExpireEvents;
    }
  }

  /**
   * Support deprecated OIAM 'expire' Events?
   *
   * To configure the feature-toggle a config is needed.
   * The OauthService.config seems to be the (temporarily) most apporopriate way
   * in concern of delivery.
   */
  public static supportDeprecatedExpireEvents(): boolean {
    return FeatureToggle.deprecatedExpireEvents;
  }
}
